<template>
    <div>
        <v-row v-if="impacto != null">
            <v-col cols="5" class="text-left">
                {{ textos[impacto]['descripcion'] }}
            </v-col>
            <v-col cols="7" class="text-left font-weight-bold">
                {{ textos[impacto]['pregunta'] }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <apex-chart v-if="categorias.length > 0" :height="200" type="bar" :options="chartOptions"
                           :series="series"></apex-chart>
            </v-col>
        </v-row>
        <v-row v-if="tipoResultado === 'dermis'">
            <v-col cols="12" class="font-italic">
                * Para el cálculo únicamente se consideran el material de recubrimiento y los materiales necesarios para
                su instalación.
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";

    export default {
        name: "GraficoEtapasAmbientales",
        props: {
            solucionesConstructivas: {type: Array, required: true},
            impactoAmbientales: {type: Object, required: true},
            resultados: {type: Array, required: true},
            id: {type: Number, required: true},
            tipoResultado: {type: String, required: true}
        },
        data: () => ({
            reultadosDetalle: null,
            codigoImpacto: null,
            impacto: null,
            impactos: [
                'gwp',
                'adf',
                'pocp',
                'odp',
                'ep',
                'adpe',
                'ap',
            ],
            textos: {
                'gwp': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Esta categoría se basa en las emisiones de gases de efecto invernadero en un horizonte temporal de 100 años, expresado como kg de CO2 equivalente/kg de gas de efecto invernadero.'
                },
                'adpe': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Aproximación que considera la concentración de reservas y el ritmo de extracción. Indicadores de agotamiento abiótico pretenden capturar la menor disponibilidad de recursos renovables como resultado de su extracción y la escasez subyacente. Se expresa en kg Sb eq.'
                },
                'adf': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Aproximación que considera la concentración de reservas y el ritmo de extracción. Indicadores de agotamiento abiótico pretenden capturar la menor disponibilidad de recursos no renovables como resultado de su extracción y la escasez subyacente. Se expresa en MJ.'
                },
                'pocp': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Se basa en las emisiones de compuestos que, mediante reacciones fotoquímicas, forman ozono en la troposfera expresado como (kg de eteno equivalente/kg de emisión foto-oxidante). Estas emisiones son principalmente compuestos orgánicos volátiles (COV) y CO.'
                },
                'odp': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Se basa en las emisiones de sustancias que reducen la capa de ozono, medido como el potencial de agotamiento de cada emisión en el aire (kg de R11 equivalente/kg de emisión). '
                },
                'ep': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Emisiones de nutrientes al aire, agua o suelo (kg de PO4-3 equivalente/kg de emisión eutrofizante). Se debe al enriquecimiento de nutrientes, básicamente de N, P y C agregados para cuantificar su contribución potencial a la formación de biomasa. Los contaminantes atmosféricos, las aguas residuales y los fertilizantes agrícolas contribuyen a la eutrofización.'
                },
                'ap': {
                    'pregunta': '¿Cómo y cuánto contribuye cada una de las etapas del ciclo de vida de las soluciones constructivas caracterizadas?',
                    'descripcion': 'Esta categoría de impacto se basa en las emisiones de sustancias acidificantes. El potencial de acidificación se mide en cantidad de dióxido de azufre equivalente (SO2-Equivalentes) y se describe como la capacidad de ciertas substancias para crear y liberar iones H+.'
                },
            },
            etapas: [
                {
                    'codigo': 'AI_A1_A3',
                    'nombre': 'producción',
                    'color': '#d485ba'
                },
                {
                    'codigo': 'AI_A4',
                    'nombre': 'transporte',
                    'color': '#7f8450'
                },
                {
                    'codigo': 'AI_A5',
                    'nombre': 'construcción',
                    'color': '#64bdb7'
                },
                {
                    'codigo': 'AI_B1',
                    'nombre': 'uso',
                    'color': '#0f2037'
                },
                {
                    'codigo': 'AI_B2',
                    'nombre': 'mantenimiento',
                    'color': '#ffaca7'
                },
                {
                    'codigo': 'AI_B3',
                    'nombre': 'reparación',
                    'color': '#cb333e'
                },
                {
                    'codigo': 'AI_B4',
                    'nombre': 'sustitución',
                    'color': '#a4d8a8'
                },

                {
                    'codigo': 'AI_C1',
                    'nombre': 'deconstrucción y derribo',
                    'color': '#cb3eca'
                },
                {
                    'codigo': 'AI_C2',
                    'nombre': 'transporte de residuos',
                    'color': '#f9781e'
                },
                {
                    'codigo': 'AI_C3',
                    'nombre': 'reutilización, recuperación y reciclaje',
                    'color': '#f9b062'
                },
                {
                    'codigo': 'AI_C4',
                    'nombre': 'eliminación final',
                    'color': '#841dcb'
                },
                {
                    'codigo': 'AI_E1',
                    'nombre': 'fin de vida',
                    'color': '#a9adb8'

                }
            ]
        }),
        computed: {
            colores() {
                let colores = [];
                this.etapas.forEach((etapa) => {
                    colores.push(etapa.color);
                });
                return colores;
            },
            series() {
                if (this.reultadosDetalle == null || this.reultadosDetalle.length == 0) return [];
                let series = [];
                this.etapas.forEach((etapa) => {
                    let datos = [];
                    let omite = {0: false, 1: false};
                    [0, 1].forEach((indice) => {
                        let resultado = this.reultadosDetalle[indice].resultados.find((resultado) => {
                            return etapa.codigo == resultado.codigo;
                        });
                        let dato = this.tipoResultado === "dermis"
                            ? resultado.dermis[this.impacto] : resultado.resultado_completa[this.impacto];
                        if (dato == 0) omite[indice] = true;
                        datos.push(dato);
                    });
                    if (!omite[0] || !omite[1]) {
                        series.push({
                            name: etapa.nombre,
                            data: datos
                        })
                    }
                });
                return series;
            },
            categorias() {
                if (this.reultadosDetalle == null || this.reultadosDetalle.length == 0) return [];
                return [this.solucionesConstructivas[0].materialDermis.nombre, this.solucionesConstructivas[1].materialDermis.nombre];
            },
            chartOptions() {
                if (this.categorias.length <= 0 || this.series.length <= 0) return {};

                let suma1, suma2;
                this.series.forEach((serie) => {
                    if (typeof suma1 === "undefined") suma1 = serie.data[0]
                    else suma1 += serie.data[0];
                    if (typeof suma2 === "undefined") suma2 = serie.data[1]
                    else suma2 += serie.data[1];
                });

                let max = suma1 > suma2 ? suma1 : suma2;

                return {
                    chart: {
                        stacked: true,
                        type: 'bar',
                        toolbar: {
                            show: false,
                        }
                    },
                    colors: this.colores,
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            barHeight: '80%',
                            columnWidth: '100%',
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        width: 1,
                        colors: ["#fff"]
                    },
                    grid: {
                        xaxis: {
                            showLines: false
                        }
                    },
                    yaxis: {
                        labels: {
                            show: true,
                            trim: false,
                            style: {
                                colors: "#40108e",
                                fontSize: "13px",
                                fontWeight: "bold",
                            },
                        },
                    },
                    tooltip: {
                        shared: false,
                        custom: (datos) => {
                            let valor = datos.series[datos.seriesIndex][datos.dataPointIndex];
                            valor = Number.parseFloat(valor.toPrecision(3)).toExponential();
                            return '<div class="tooltip-resultado">' +
                                '<span class="titulo">' + this.series[datos.seriesIndex].name + '</span><br>' +
                                valor + ' ' + this.impactoAmbientales.unidades_no_interpolado + '</div>';
                        }
                    },
                    xaxis: {
                        categories: this.categorias,
                        tickAmount: 10,
                        labels: {
                            trim: false,
                            formatter: function (val) {
                                return Number.parseFloat(val.toPrecision(3)).toExponential();
                            }
                        },
                        max: max + (max * 0.03),
                    },
                }
            }
        },
        mounted() {
            this.impacto = this.impactos.find((inpacto) => {
                return this.impactoAmbientales.codigo.toLowerCase().trim().includes(inpacto);
            });
            HttpHelper.get(`proyecto/${this.id}/grafico-etapas-ambientales`)
                .then((res) => {
                    this.reultadosDetalle = res;
                })
                .finally(() => {
                    this.cargando = false;
                });
        },
        methods: {
            convertirAFlotante(numero) {
                return parseFloat(numero.replace(",", "."));
            }
        }
    }
</script>

<style lang="scss">
    .tooltip-resultado {
        padding: 10px;
        width: auto;
        font-weight: bolder;

        .titulo {
            font-weight: bolder;
            text-transform: capitalize;
        }
    }
</style>